var map = {
	"./033-bm.webp": 1199,
	"./033-cn.webp": 1200,
	"./033.webp": 1201,
	"./13-bm.webp": 1202,
	"./13-cn.webp": 1203,
	"./13.webp": 1204,
	"./3-bm.webp": 1205,
	"./3-cn.webp": 1206,
	"./3.webp": 1207,
	"./angpao-bg-mobile.jpg": 1208,
	"./angpao-bg.jpg": 1209,
	"./angpao-bm.webp": 1210,
	"./angpao-cn.webp": 1211,
	"./angpao.webp": 1212,
	"./button.png": 1213,
	"./close-eye.png": 1214,
	"./coin-1.png": 1215,
	"./coin.png": 1216,
	"./ketupak-open.png": 1217,
	"./ketupak.png": 1218,
	"./ketupak_ribbon.png": 1219,
	"./rain-1.png": 1220,
	"./rain-2.png": 1221,
	"./rain-3.png": 1222,
	"./raya-bg-mobile.png": 1223,
	"./raya-bg.png": 1224,
	"./shine.png": 1225,
	"./star-1.png": 1226,
	"./star-2.png": 1227
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 453;